var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchLarge = function SvgSearchLarge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6 6C12.5366 6 6 12.5366 6 20.6C6 28.6634 12.5366 35.2 20.6 35.2C23.9105 35.2 26.9636 34.0982 29.4127 32.2413L39.5857 42.4142L42.4141 39.5858L32.2412 29.4129C34.0982 26.9637 35.2 23.9105 35.2 20.6C35.2 12.5366 28.6634 6 20.6 6ZM10 20.6C10 14.7458 14.7458 10 20.6 10C26.4542 10 31.2 14.7458 31.2 20.6C31.2 26.4542 26.4542 31.2 20.6 31.2C14.7458 31.2 10 26.4542 10 20.6Z",
    fill: "#0A0A0A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SearchLarge.4d3055033a93657b32233ba0dadb3253.svg";